import React from 'react';
import { PhoneIcon, ShieldCheckIcon, AwardIcon } from 'lucide-react';
export function TopBar() {
  return <div className="bg-charcoal text-alabaster/70 py-1 px-6 border-b border-white/10 text-[10px] md:text-xs font-bold uppercase tracking-[0.15em]" data-id="element-196">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-2" data-id="element-197">
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-198">
          <div className="flex items-center gap-2" data-id="element-199">
            <ShieldCheckIcon className="w-3 h-3 text-espresso" data-id="element-200" />
            <span data-id="element-201">Fully Licensed & Insured</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-202">
            <AwardIcon className="w-3 h-3 text-espresso" data-id="element-203" />
            <span data-id="element-204">MHIC #123456 • VA Class A</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-205">
            <span className="text-espresso" data-id="element-206">●</span>
            <span data-id="element-207">$2M General Liability Coverage</span>
          </div>
        </div>
        <div className="flex items-center gap-2 text-alabaster" data-id="element-208">
          <PhoneIcon className="w-3 h-3 text-espresso" data-id="element-209" />
          <a href="tel:4107776984" className="hover:text-espresso transition-colors" data-id="element-210">
            (410) 777-6984
          </a>
        </div>
      </div>
    </div>;
}